/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */
export var getValueFromTextNode = function getValueFromTextNode(obj) {
  var textNodeName = "#text";

  for (var key in obj) {
    if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) {
      obj[key] = obj[key][textNodeName];
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      obj[key] = getValueFromTextNode(obj[key]);
    }
  }

  return obj;
};